import * as React from "react"
import { connect } from "react-redux"
import { GlobalState } from "../../../store"
import { mapDispatchToProps, DispatchProps } from "../actions"

import { Action, ActionType } from "@tenforce/toolbox-button-push-react"
import { Modal } from "@tenforce/toolbox-modal-react"
import { ButtonSymbols } from "../../../symbols"

interface OwnProps {
    confirmAction: () => void
}

type StateProps = ConfirmationDialog.ConfirmationDialog
type Props = OwnProps & StateProps & DispatchProps

export class Dialog extends React.PureComponent<Props> {
    render(): JSX.Element {
        const {
            cancelIcon,
            cancelText,
            confirmIcon,
            confirmText,
            isVisible,
            title,
        } = this.props

        return (
            <>
                <Modal
                    isShown={isVisible}
                    containerProps={{
                        id: "confirmationDialog",
                        isCenterFixedPositioned: true,
                        blockOverlayInteraction: true,
                        onClose: this.hideModal,
                    }}
                    contentProps={{
                        extraClasses: "tw-w-1/3 tw-mx-auto bg-default",
                    }}
                >
                    <div className="tw-p-4">
                        <h3>{title}</h3>
                    </div>
                    <div className="separator-line is-dotted is-dimmed"></div>
                    <div className="tw-p-4">
                        <Action
                            actionType={ActionType.button}
                            onClick={this.onConfirm}
                            data-ft-component="confirmButton"
                        >
                            {ButtonSymbols.has(confirmIcon) &&
                                ButtonSymbols.get(confirmIcon)}
                            &nbsp;
                            {confirmText}
                        </Action>
                        <Action
                            actionType={ActionType.button}
                            isTransparent={true}
                            isSecondary={true}
                            onClick={this.hideModal}
                            data-ft-component="cancelButton"
                        >
                            {ButtonSymbols.has(cancelIcon) &&
                                ButtonSymbols.get(cancelIcon)}
                            &nbsp;
                            {cancelText}
                        </Action>
                    </div>
                </Modal>
            </>
        )
    }

    hideModal = (): void => {
        this.props.updateVisibility(false)
    }

    onConfirm = (): void => {
        this.hideModal()
        this.props.confirmAction()
    }
}

const mapStateToProps = (state: GlobalState): StateProps =>
    state.confirmationDialog

export default connect(mapStateToProps, mapDispatchToProps)(Dialog)
